import { render, staticRenderFns } from "./DialogNote.vue?vue&type=template&id=394c59da&scoped=true&"
import script from "./DialogNote.vue?vue&type=script&lang=js&"
export * from "./DialogNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c59da",
  null
  
)

export default component.exports